import { render } from "./UploadPreview.vue?vue&type=template&id=3627d1ae"
import script from "./UploadPreview.vue?vue&type=script&lang=js"
export * from "./UploadPreview.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__